module.exports = __webpack_public_path__ + "static/media/Arnold.2a5011e7.png";